import {EventEmitter, Injectable} from '@angular/core';
import {ConstantsService} from "../fidelidade/ConstantsService";
import {DeviceDetectorService} from "ngx-device-detector";
import {ProcessadorReciboTexto} from "./impressao/ProcessadorReciboTexto";
import {PedidosService} from "./pedidos.service";
import {ProcessadorNfceTexto} from "./impressao/ProcessadorNfceTexto";
import {JobImpressaoService} from "./job-impressao.service";
import {ProcessadorCaixaTexto} from "./impressao/ProcessadorCaixaTexto";

declare var qz: any;


@Injectable({
  providedIn: 'root'
})
export class ImpressaoService {
  printer: any;
  qzInstalado = false;
  conectou: EventEmitter<boolean> = new EventEmitter();
  private realizouTentativaDeConexao: boolean;
  conectando = false;
  conectandoQzTray: EventEmitter<boolean> = new EventEmitter<boolean>()
  onErrosImpressao: any =   new EventEmitter<any>()
  impressoras: string[];
  imprimindo = false;
  qtdImpressoes = 0;
  public filaImpressao = [];
  imprimindoEmLote = false;
  categorias: any = []
  onImpresssaoRemota  = new EventEmitter();
  constructor(private constantsService: ConstantsService, private pedidosService: PedidosService,
              private deviceService: DeviceDetectorService, private jobImpressaoService: JobImpressaoService) {
    if(this.deviceService.isMobile())   return;
    this.conectandoQzTray.emit(true)
    qz.security.setCertificatePromise((resolve, reject) => {
      fetch("/assets/cert/cert.pem", {cache: 'no-store', headers: {'Content-Type': 'text/plain'}})
        .then( (data) => {
          console.log(data);
          if(data.ok) {
            let texto = data.text();
            console.log(texto);
            return resolve(texto);
          }
          this.onErrosImpressao.emit('não foi possível carregar o certificado do qz-tray')
          reject(data.text())

        });
    })

    qz.security.setSignatureAlgorithm("SHA512");
    qz.security.setSignaturePromise(function(toSign) {
      return function(resolve, reject) {
        fetch("/pedidos/impressao/assine?request=" + toSign, {cache: 'no-store', headers: {'Content-Type': 'text/plain'}})
          .then(function(data) { data.ok ? resolve(data.text()) : reject(data.text()); });
      };
    });

    this.constantsService.empresa$.subscribe( (empresa) => {
      if( !empresa ) return;
      this.conectando = true
      this.categorias = empresa.catalogo.categorias;
      qz.websocket.connect().then(() => {
        this.realizouTentativaDeConexao = true;
        this.conectando = false;

        this.qzInstalado = true;
        qz.printers.find().then(data => {
          data.sort();
          console.log(data);
          this.impressoras = data;
          this.conectou.emit(true)
        })
        /*
        if(empresa.configImpressao.imprimirTXT && empresa.configImpressao.impressora) {
          qz.printers.find(empresa.configImpressao.impressora.nome).then((found) => {
            this.printer = found;
          });
        } else
          this.printer = null;

         */

      }).catch((erro) => {
        this.realizouTentativaDeConexao = true;
        this.conectou.emit(false)
        this.qzInstalado = false;
        this.conectando = false;
        console.error(erro)
      });

    });

  }

  conecteQZ() {
    return new Promise((resolve) => {
      this.conectando = true
      qz.websocket.connect().then(() => {
        this.conectando = false
        this.realizouTentativaDeConexao = true;
        this.qzInstalado = true;

        qz.printers.find().then(data => {
          data.sort();
          console.log(data);
          this.impressoras = data;
          resolve(null);
        })

        /*
        if(empresa.configImpressao.imprimirTXT && empresa.configImpressao.impressora) {
          qz.printers.find(empresa.configImpressao.impressora.nome).then((found) => {
            this.printer = found;
          });
        } else
          this.printer = null;

         */

      }).catch((erro) => {
        this.realizouTentativaDeConexao = true;
        this.conectou.emit(false)
        this.conectando = false;
        this.qzInstalado = false;
        console.error(erro)
        this.onErrosImpressao.emit('Não foi possível conectar a impressora. O qz-tray está aberto?')
        resolve(null);
      })
    })
  }

  possuiQZ() {
    return new Promise((resolve) => {
      if(qz.websocket.isActive()) return resolve(true)
      this.conectandoQzTray.emit(true)
      if(this.conectando) {
        let inscricao = this.conectou.subscribe((conectou: boolean) => {
          inscricao.unsubscribe();

          if (conectou) {
            setTimeout(() => {
              this.conectandoQzTray.emit(false)
            }, 0)

            return resolve(conectou);
          }

          this.conecteQZ().then(() => {
            setTimeout(() => {
              this.conectandoQzTray.emit(false)
            }, 0)

            if (!qz.websocket.isActive()) {
              this.onErrosImpressao.emit('Não foi possível conectar a impressora. O qz-tray está aberto?');
            }

            return resolve(qz.websocket.isActive())
          })
        })
      } else {
        this.conecteQZ().then(() => {
          setTimeout(() => {
            this.conectandoQzTray.emit(false)
          }, 0)

          if (!qz.websocket.isActive()) {
            this.onErrosImpressao.emit('Não foi possível conectar a impressora. O qz-tray está aberto?');
          }

          return resolve(qz.websocket.isActive())
        })
      }
    })
  }

  imprimaHTML(url: string, impressora: any, impressoraTinta = null): Promise<boolean> {
    return new Promise<boolean>(async (resolve) => {
      if(this.imprimindo) {
        setTimeout(() => {
          this.imprimaHTML(url, impressora).then(async (resultado) =>
          resolve(resultado));
          }, 1000);
        return;
      }
      this.imprimindo = true;

      let timeoutBotarFalse = setTimeout(() => { this.imprimindo = false; }, 10000)

      try {

        this.qtdImpressoes++;

        console.log("Job número " + this.qtdImpressoes);


        let nomeImpressora

        //if(isDevMode())
//          url = "http://localhost:3100" + url

        console.log('url: ' + url)

        for(let i = 0; i < this.impressoras.length; i++)
          if(this.impressoras[i].toLowerCase().indexOf(impressora.nome.toLowerCase()) >= 0)
          {
            nomeImpressora = this.impressoras[i];
            break;
          }

        for(let i = 0; i <  this.impressoras.length; i++)
          if(this.impressoras[i] === impressora.nome)
          {
            nomeImpressora = this.impressoras[i];
            break;
          }


        if(!nomeImpressora) {
          this.imprimindo = false;
          clearTimeout(timeoutBotarFalse);
          throw new Error("Não foi possível econtrar a impressora " + impressora.nome + " neste computador.")
        }

        let params: any = { encoding: 'Cp1252'};
        let config = qz.configs.create(nomeImpressora, params);

        let data: any = [{
          type: 'html',
          format: 'file', // or 'plain' if the data is raw HTML
          data: url,
          options: { language: "ESCPOS" }
        }]

        if(impressoraTinta){
          config = qz.configs.create(nomeImpressora);

          const response = await fetch(url);
          const pdfData = await response.blob();
          // Converter o Blob para ArrayBuffer
          const arrayBuffer = await pdfData.arrayBuffer()

          async function arrayBufferToBase64(buffer) {
            let binary = '';
            const bytes = new Uint8Array(buffer);
            const len = bytes.byteLength;
            for (let i = 0; i < len; i++) {
              binary += String.fromCharCode(bytes[i]);
            }
            return window.btoa(binary);
          }

          const base64Data = await arrayBufferToBase64(arrayBuffer); // Convertendo para Base64


          data = [{
            type: 'pdf',
            format: 'base64', // Mude para base64
            data: base64Data
          }];

          console.log("Dados para impressão:", data); // Verifique a estrutura
        }


        qz.print(config, data).then(( ) => {
          let feed = []

          if(impressora.comandosFimImpressao && impressora.cortarAutomatico) {
            let comandos = this.convertaParaArrayHex(impressora.comandosFimImpressao)
            for(let comando of comandos)
              feed.push(comando)
          }

          if(impressora.emitirBeep) {
            let quantidadeBeeps = String.fromCharCode(impressora.quantidadeBeeps)
            let duracaoBeep = String.fromCharCode(Math.floor(impressora.duracaoBeep / 100))
            let comando = '\x1B\x28\x41\x05\x00\x61\x64' + quantidadeBeeps + duracaoBeep + '\x05'
            feed.push(comando)
          }

          if(impressora.cortarAutomatico) {
            feed.push('\x1B' + '\x69')
            qz.print(config,  feed).then(() => {
              this.imprimindo = false;
              clearTimeout(timeoutBotarFalse);
            }).catch((e) => {
              this.imprimindo = false;
              clearTimeout(timeoutBotarFalse);
              console.error(e); }).finally(() => {
              this.imprimindo = false;
              clearTimeout(timeoutBotarFalse);
            })
          } else if(impressora.emitirBeep) {
            qz.print(config,  feed).then(() => {
              this.imprimindo = false;
              clearTimeout(timeoutBotarFalse);
            }).catch((e) => {
              this.imprimindo = false;
              clearTimeout(timeoutBotarFalse);
              console.error(e); }).finally(() => {
              this.imprimindo = false;
              clearTimeout(timeoutBotarFalse);
            })
          } else {
            this.imprimindo = false;
            clearTimeout(timeoutBotarFalse);
          }

          resolve(true)

        }).catch((e) => {
          this.imprimindo = false;
          clearTimeout(timeoutBotarFalse);
          console.error(e);
        }).finally(() => {
          this.imprimindo = false;
          clearTimeout(timeoutBotarFalse);
          resolve(false)
        })


      } catch(e) {
        this.imprimindo = false;
        clearTimeout(timeoutBotarFalse);
        resolve(false)
        console.error(e);
      }
    })

  }

  async imprimaTexto(texto: string, impressora: any) {
    let nomeImpressora;

    if(!this.impressoras || !this.impressoras.length)
      throw new Error("Nenhuma impressora disponível para impressão")

    for(let i = 0; i < this.impressoras.length; i++)
      if(this.impressoras[i].toLowerCase().indexOf(impressora.nome.toLowerCase()) >= 0)
      {
        nomeImpressora = this.impressoras[i];
        break;
      }

    for(let i = 0; i < this.impressoras.length; i++)
      if(this.impressoras[i] === impressora.nome)
      {
        nomeImpressora = this.impressoras[i];
        break;
      }

    if(!nomeImpressora)
      throw new Error("Não foi possível encontrar a impressora " + impressora.nome + " neste computador.")

    let config = qz.configs.create(nomeImpressora, { encoding: 'Cp1252'});

    let paginas = texto.split(ProcessadorReciboTexto._MARCADOR_FIM_PAPEL).filter(x => x)

    console.log(paginas)
    console.log("Quantidade de paginas a imprimir: " + paginas.length)



    for(let pagina of paginas) {
      await this.imprimaPaginaTexto(pagina, config, impressora).catch((error: any) => {
        console.error(error)
        throw new Error(error.message || error)
      })
    }

  }

  marqueProdutosDaImpressora(impressora: any, pedido: any){
    impressora.produtos = []

    pedido.itens.map( itemPedido => itemPedido.produto).forEach(produto => {
      if(produto.categoria){
        let categoria = this.categorias.find( cat => cat.id === produto.categoria.id);

        if(categoria && categoria.impressoras.length){
          categoria.impressoras.map(item => item.id).forEach((impressoraId: number) => {
             if(impressoraId === impressora.id)
               impressora.produtos.push(produto)
          })
        }
      }
    });
  }

  async imprimaPedidoNaImpressora(pedidoCompleto, impressora: any, pedidoMarcado: any = null) {
    try {
      if(!impressora.servidorImpressao){
        this.marqueProdutosDaImpressora(impressora, pedidoCompleto)

        let processadorDeRecibo = new ProcessadorReciboTexto(impressora)

        const imprimiu = await this.imprima(processadorDeRecibo.obtenhaRecibo(pedidoCompleto, impressora.layout),
          processadorDeRecibo.impressora, null,  pedidoMarcado || pedidoCompleto)

        if (imprimiu)
          await this.marquePedidoImpresso(pedidoMarcado || pedidoCompleto, impressora.impressaoAuto);

        // Se não imprimiu, mas não lançou erro, ainda retornamos false para indicar falha
        return imprimiu
      } else {
        await this.envieImprimirRemotamente(pedidoCompleto, impressora);
        return true;
      }
    } catch (erro) {
      // Propagar o erro após exibi-lo
      console.error("Erro na impressão:", erro)
      throw erro
    }
  }

  private async imprimaPaginaConteudo(conteudo: any[], config: any, impressora: any) {
    return new Promise((resolve: any, reject: any) => {
      console.log("Imprimindo conteúdo misto");
      console.log(conteudo);

      let data: any[] = [];

      if (!impressora.naoInicializaImpressao)
        data.push('\x1B\x40');

      for (let parte of conteudo) {
        if (!parte)
          continue;

        if (typeof parte === 'string') {
          let linhas = parte.split("\n");
          linhas = linhas.map(i => i.normalize("NFD").replace(/[\u0300-\u036f]/g, "") + "\n");

          for (let linha of linhas)
            data.push(linha);
        } else {
          data.push(parte);
        }
      }

      console.log("Dados a serem impressos: ", data);

      qz.print(config, data).then(() => {
        let feed: any[] = [];

        feed.push('\x0A');
        feed.push('\x0A');

        if (impressora.comandosFimImpressao) {
          let comandos = this.convertaParaArrayHex(impressora.comandosFimImpressao);
          for (let comando of comandos)
            feed.push(comando);
        }

        if (impressora.emitirBeep) {
          let quantidadeBeeps = String.fromCharCode(impressora.quantidadeBeeps);
          let duracaoBeep = String.fromCharCode(Math.floor(impressora.duracaoBeep / 100));
          let comando = '\x1B\x28\x41\x05\x00\x61\x64' + quantidadeBeeps + duracaoBeep + '\x05';
          console.log(comando);
          feed.push(comando);
        }

        feed.push('\x1B\x69');

        qz.print(config, feed).then(function() {
          resolve();
        }).catch((error: any) => {
          console.error(error);
          return reject(error);
        });

      }).catch((error: any) => {
        console.error(error);
        reject(error);
      });
    });
  }

  async imprimaConteudo(conteudo: any[], impressora: any) {
    let nomeImpressora;

    if (!this.impressoras || !this.impressoras.length)
      throw new Error("Nenhuma impressora disponível para impressão");

    for (let i = 0; i < this.impressoras.length; i++)
      if (this.impressoras[i].toLowerCase().indexOf(impressora.nome.toLowerCase()) >= 0) {
        nomeImpressora = this.impressoras[i];
        break;
      }

    for (let i = 0; i < this.impressoras.length; i++)
      if (this.impressoras[i] === impressora.nome) {
        nomeImpressora = this.impressoras[i];
        break;
      }

    if (!nomeImpressora)
      throw new Error("Não foi possível encontrar a impressora " + impressora.nome + " neste computador.");

    let config = qz.configs.create(nomeImpressora, { encoding: 'Cp1252' });

    console.log(conteudo);
    console.log("Quantidade de partes a imprimir: " + conteudo.length);

    await this.imprimaPaginaConteudo(conteudo, config, impressora).catch((error: any) => {
      console.error(error);
      throw new Error(error.message || error);
    });
  }

  async imprimaNfceNaImpressora(nfce: any, impressora: any) {
    try {
      const processadorNfce = new ProcessadorNfceTexto(impressora);
      const conteudo = processadorNfce.obtenhaConteudoNfce(nfce);

      const imprimiu = await this.possuiQZ().then(async (possui: boolean) => {
        try {
          if (!possui)
            throw new Error('É necessário instalar/iniciar o QZ Tray antes de realizar a impressão');

          if (!impressora)
            throw new Error('É necessário informar a impressora');

          let erroTexto: string;

          await this.imprimaConteudo(conteudo, processadorNfce.impressora).catch((error: any) => {
            erroTexto = error?.message;
          });

          if (erroTexto)
            throw new Error(erroTexto);

          return Promise.resolve(true);
        } catch (erro: any) {
          if (nfce) nfce.erroImpressao = (erro?.message || erro);
          this.emitaErroImpresso(`Houve um erro ao imprimir NFCe: ${erro}`, nfce?.id);
          return Promise.resolve(false);
        }
      });

      return imprimiu;
    } catch (erro: any) {
      console.error('Erro ao imprimir NFCe:', erro);
      this.onErrosImpressao.emit(`Erro ao imprimir NFCe: ${erro?.message || erro}`);
      return false;
    }
  }


  async envieImprimirRemotamente(pedido: any, impressora: any){
    this.marquePedidoImprimir(pedido);
    this.onImpresssaoRemota.emit({ mensagem: 'Processando impressão remota...', processando: true})
    const job: any = await this.jobImpressaoService.crieJobPedido(pedido, impressora).catch((err) => {
      this.marqueErroImpresso(pedido, 'Falha ao criar job impressão remota: ' + err)
      this.onErrosImpressao.emit(  pedido.erroImpressao);
    });

    if(job){
      this.onImpresssaoRemota.emit({ mensagem: 'Impressão enviada com sucesso...'})
      ////salvar job para mostrar status da impressão...
    }
  }

  async envieImprimirRemotamenteComanda(comanda: any, impressora: any){
    this.marquePedidoImprimir(comanda);
    this.onImpresssaoRemota.emit({ mensagem: 'Processando impressão remota...', processando: true})
    const job: any = await this.jobImpressaoService.crieJobComanda(comanda, impressora).catch((err) => {
      this.marqueErroImpresso(comanda, 'Falha ao criar job impressão remota: ' + err)
      this.onErrosImpressao.emit(  comanda.erroImpressao);
    });

    if(job){
      this.onImpresssaoRemota.emit({ mensagem: 'Impressão enviada com sucesso...'})
      ////salvar job para mostrar status da impressão...
    }
  }

  async imprimaQzTrayComanda(comanda: any, impressora: any){
    let pedidoCompleto: any =  await this.pedidosService.obtenhaComandaComoPedido(comanda.id).catch( (erro) => {
      console.log(erro)
      this.marqueErroImpresso(comanda, erro)
      this.onErrosImpressao.emit(comanda.erroImpressao);
      return false;
    });

    if(pedidoCompleto) {
      let imprimiu: boolean;

      console.log(pedidoCompleto)
      let processadorDeRecibo = new ProcessadorReciboTexto(impressora)
      console.log(impressora)

      if (impressora.modoHTML) {
        const resumido = (impressora.layout === 'PedidoResumido');
        const id = impressora?.id || impressora?._id;
        const idParam = id ? `&idImpressora=${encodeURIComponent(String(id))}` : '';

        imprimiu = await this.imprima(
          `/pedidos/comanda/${comanda.id}/comprovante?resumido=${resumido}${idParam}`,
          processadorDeRecibo.impressora,
          'Imprimir comanda',
          comanda
        )
      } else {
        imprimiu = await this.imprima(
          processadorDeRecibo.obtenhaRecibo(pedidoCompleto, impressora.layout),
          processadorDeRecibo.impressora,
          'Imprimir comanda',
          comanda
        )
      }

      if (imprimiu)
        this.marqueComandaImpressa(comanda)

      return imprimiu;
    }
  }

  async imprimaQzTray(pedido: any, impressora: any){
    try {

      //se ja esta sendo impresso , nao deve acumular....
      if(pedido.imprimindo){

      }

      this.marquePedidoImprimir(pedido);

      let  pedidoCompleto: any = await  this.pedidosService.obtenhaPorCodigo(pedido.guid).catch((err) => {
           this.marqueErroImpresso(pedido, 'Falha ao carregar pedido: ' + err)
           this.onErrosImpressao.emit(  pedido.erroImpressao);
      });

      if(pedidoCompleto)
          await this.imprimaPedidoNaImpressora(pedidoCompleto, impressora, pedido)

    } catch(erro) {
      console.error(erro)
      this.marqueErroImpresso(pedido, erro)
      this.onErrosImpressao.emit(  pedido.erroImpressao);
    }
  }

  async imprimaResumoCaixa(resumoCaixa: any, impressora: any) {
    const processadorCaixa = new ProcessadorCaixaTexto(impressora);
    const usaLayoutA4 = impressora?.tamanhoPapel === 'LayoutA4';

    if (impressora?.modoHTML || usaLayoutA4) {
      return this.imprima(
        this.getRelatorioCaixaUrl({
          idCaixa: resumoCaixa?.id,
          idImpressora: impressora?.id || impressora?._id,
          a4: usaLayoutA4
        }),
        processadorCaixa.impressora,
        'Imprimir relatÃ³rio de caixa',
        resumoCaixa
      );
    }

    return this.imprima(
      processadorCaixa.obtenhaResumoCaixa(resumoCaixa),
      processadorCaixa.impressora,
      'Imprimir relatÃ³rio de caixa',
      resumoCaixa
    );
  }

  marquePedidoImprimir(pedido: any){
    pedido.imprimindo = true;
    pedido.aguardando = false;
    delete pedido.erroImpressao
  }

  async marquePedidoImpresso(pedido: any, impressaoAuto = null){
    pedido.impresso = true;
    pedido.imprimindo = false;
    pedido.aguardando = false;
    delete     pedido.erroImpressao;

    await this.pedidosService.marqueFoiImpresso(pedido, impressaoAuto)
  }

  marqueComandaImpressa(comanda: any){
    comanda.impressa = true;
    comanda.imprimindo = false;
    comanda.aguardando = false;
    delete     comanda.erroImpressao;
  }

  marqueErroImpresso(pedido: any, erro: string){
    pedido.imprimindo = false;
    pedido.aguardando = false;
    pedido.erroImpressao = erro;
  }

  imprima(texto: string, impressora: any, operacao: string = null, objeto: any = null): Promise<boolean> {
    return this.possuiQZ().then( async (possui: boolean) => {
      try{
        if(!possui)
          throw new Error("É necessário instalar/iniciar o QZ Tray antes de realizar a impressão")

        if(!impressora )
          throw new Error("É necessário informar a impressora")

        let impressoraTinta = impressora.tamanhoPapel === 'LayoutA4';

        if(impressora.modoHTML || impressoraTinta){
          let impresso = await this.imprimaHTML(texto, impressora, impressoraTinta)
          return Promise.resolve(impresso)
        } else{
          let erroTexto;

          await this.imprimaTexto(texto, impressora).catch((error: any) => {
            erroTexto = error.message || error;
          })

          if(erroTexto)
            throw new Error(erroTexto)
        }

        return Promise.resolve(true)
      }catch (erro){
        if(objeto) objeto.erroImpressao =  (erro.message || erro);
        this.emitaErroImpresso(`Houve um erro ${operacao ? ' ao ' + operacao : ' ao imprimir'}: ${erro}`, objeto?.id)
        return Promise.resolve(false)
      }
    })

  }

  private emitaErroImpresso(erro: string, id: number){
    let pedido: any;

    if(id)
     pedido = this.filaImpressao.find((item: any) => item.id === id);

    if(pedido) //exibir erro fila de impressao
      this.marqueErroImpresso(pedido, erro)
    else
      this.onErrosImpressao.emit(erro)

  }

  private convertaParaArrayHex(comandosFimImpressao: string) {
    return comandosFimImpressao.replace(/\\x([0-9A-F]{2})/ig, function() {
      return String.fromCharCode(parseInt(arguments[1], 16));
    }).split(',');
  }

  listeImpressoras() {
    return new Promise((resolve: any) => {
      this.possuiQZ().then((possui: boolean) => {
        if(!possui) {
          resolve({
            sucesso: false,
            erro: 'Não foi possível listar as impressoras. O QZ-tray está aberto?'
          })
        }
        qz.printers.find().then(function(data) {
          data.sort();
          resolve({
            sucesso: true,
            data: data
          })
        }).catch(function(e) {
          resolve({
            sucesso: false,
            erro: e
          })
        });

      })

    })
  }

  private async imprimaPaginaTexto(pagina: string, config: any, impressora: any) {
    return new Promise((resolve: any, reject: any) => {
      console.log("Imprimindo página")
      console.log(pagina)
      let linhas = pagina.split("\n")
      linhas = linhas.map(i =>  i.normalize("NFD").replace(/[\u0300-\u036f]/g, "") + "\n");

      //linhas.push('\x1B' + '\x69')

      // '\x1B\x28\x41\x04\x00\x31\x1F4\x3E800\x01' fn n1
      //  n2
      //  vol

      let data = impressora.naoInicializaImpressao ?  linhas : ['\x1B' + '\x40'].concat(linhas);

      console.log("Dados a serem impressos: ", data)

      return qz.print(config,  data).then((err) => {
        let feed = []

        feed.push('\x0A')
        feed.push('\x0A')

        if(impressora.comandosFimImpressao) {
          let comandos = this.convertaParaArrayHex(impressora.comandosFimImpressao)
          for(let comando of comandos)
            feed.push(comando)
        }

        if(impressora.emitirBeep) {
          let quantidadeBeeps = String.fromCharCode(impressora.quantidadeBeeps)
          let duracaoBeep = String.fromCharCode(Math.floor(impressora.duracaoBeep / 100))
          let comando = '\x1B\x28\x41\x05\x00\x61\x64' + quantidadeBeeps + duracaoBeep + '\x05'
          console.log(comando)
          feed.push(comando)
        }


        //  if(impressora.cortarAutomatico) {
        feed.push('\x1B' + '\x69')
        qz.print(config,  feed).then(function() {
          resolve();
        }).catch((error: any) => {
          console.error(error)
          return reject(error)
        });
        //  }

      }).catch((error: any) => {
        console.error(error)
        reject(error)
      })
    })
  }

  async imprimaEmLote(pedidos: any[], impressora: any) {
    try{
      this.imprimindoEmLote = true;
      for(let i = 0; i <  pedidos.length; i++){
        let pedido =  Object.assign({}, pedidos[i]);

        pedido.aguardando =  true;
        pedido.impressora = impressora;

        this.filaImpressao.splice(0, 0, pedido);
      }

      await this.imprimaPedidosDaFila(impressora);

    } finally {
      this.imprimindoEmLote = false;
    }

  }

  async reimprimaPedidoNaFila(pedido: any){
    pedido.impresso = false;
    await this.imprimaQzTray(pedido, pedido.impressora);
  }

  async imprimaPedidosDaFila(impressora) {
    for(let i = 0; i <  this.filaImpressao.length; i++){
      let pedido: any = this.filaImpressao[i];

      if(!pedido.impresso)
        await this.imprimaQzTray(pedido, impressora);

    }
  }

  limpeFilaImpressao(){
    this.filaImpressao   = [];
  }

  async obtenhaDetalhesImpressora(nome: string) {
    try {
      const printers = await qz.printers.details(nome);
      console.log('Detalhes da impressora:', printers);

      if (printers && printers.length > 0) {
        const printer = printers.find((item: any) => item.name === nome);

        if (printer) {
          return {
            sucesso: true,
            data: {
              nome: printer.name,
              status: printer.connected ? 'Conectada' : 'Desconectada',
              localizacao: printer.port || 'Local',
              tipo: printer.driver || 'Driver padrão',
              porta: printer.port,
              driver: printer.driver,
              conectada: printer.connected,
              suportaCores: printer.color || false,
              suportaDuplex: printer.duplex || false,
              resolucao: printer.resolution || 'Padrão'
            }
          };
        }
      }

      // Fallback se não conseguir obter detalhes
      return {
        sucesso: true,
        data: {
          nome: nome,
          status: 'Disponível',
          localizacao: 'Local',
          tipo: 'Impressora Local',
          porta: 'Local',
          driver: 'Driver padrão',
          conectada: true,
          suportaCores: false,
          suportaDuplex: false,
          resolucao: 'Padrão'
        }
      };
    } catch (erro) {
      console.error('Erro ao obter detalhes da impressora:', erro);
      return {
        sucesso: false,
        erro: 'Erro ao obter detalhes da impressora: ' + erro.message
      };
    }
  }

  getPreviewLayoutUrl(payload: any): string {
    const params = new URLSearchParams();

    if (payload?.idImpressora)
      params.set('idImpressora', String(payload.idImpressora));

    if (payload?.impressora)
      params.set('impressora', JSON.stringify(payload.impressora));

    if (payload?.resumido !== undefined)
      params.set('resumido', payload.resumido ? 'true' : 'false');

    if (payload?.opcoesLayout)
      params.set('opcoesLayout', JSON.stringify(payload.opcoesLayout));

    return `/pedidos/impressao/preview-layout?${params.toString()}`;
  }

  getRelatorioCaixaUrl(payload: any): string {
    const params = new URLSearchParams();
    const idCaixa = payload?.idCaixa;

    if (!idCaixa)
      throw new Error('Ã‰ necessÃ¡rio informar o caixa para gerar o relatÃ³rio');

    if (payload?.idImpressora)
      params.set('idImpressora', String(payload.idImpressora));

    if (payload?.autoPrint)
      params.set('autoprint', '1');

    const sufixo = payload?.a4 ? '/a4' : '';
    const query = params.toString();

    return `/caixa/${encodeURIComponent(String(idCaixa))}/relatorio${sufixo}${query ? '?' + query : ''}`;
  }
}
